import { useEffect, useState } from "react";

export const getFileIcon = (fileType: string): string => {
    if (fileType.startsWith("image/")) return "🖼️";
    if (fileType === "text/plain") return "📄";
    if (fileType.includes("excel") || fileType.includes("spreadsheet"))
        return "📊";
    if (fileType.includes("pdf")) return "📑";
    if (fileType.includes("word") || fileType.includes("document")) return "📝";
    if (fileType.includes("exe")) return "⚙️";
    return "📁";
};

export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const toDateTimeStr = (
    timestamp: string | number | null | undefined
): string => {
    if (!timestamp) return "N/A";

    try {
        const timestampNum =
            typeof timestamp === "string" ? parseInt(timestamp) : timestamp;
        const dateObj = new Date(timestampNum);

        const day = dateObj.getDate().toString().padStart(2, "0");
        const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
        const year = dateObj.getFullYear();
        const hours = dateObj.getHours().toString().padStart(2, "0");
        const minutes = dateObj.getMinutes().toString().padStart(2, "0");

        return `${day}.${month}.${year} ${hours}:${minutes}`;
    } catch (error) {
        console.error("Error formatting timestamp:", error);
        return "Invalid date";
    }
};


export const useDebounce = (value: string, delay: number) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};